import { keyframes } from "styled-components";

const RollFromLeft = (props) => {
  return keyframes`
    from {
      transform: translateX(-35%) ${props.flip? "scaleX(-1)" : ""};
      opacity: 0;

    }

    to {
      transform: translateX(0) ${props.flip? "scaleX(-1)" : ""};
      opacity: 1;
    }
  `;
}

export default RollFromLeft;
